// Theme-Override für Input-Komponente, damit das Label auch bei disabled Inputs sichtbar bleibt
import erecht24InputTheme from "@erecht24/frontend-kit/theme/components/inputs/erecht24-input-theme";

const customInputTheme = {
    ...erecht24InputTheme,
    input: {
        ...erecht24InputTheme.input,
        styles: {
            ...erecht24InputTheme.input.styles,
            base: {
                ...erecht24InputTheme.input.styles.base,
                label: {
                    ...erecht24InputTheme.input.styles.base.label,
                    // Überschreibe disabled, damit das Label sichtbar bleibt
                    disabled: undefined,
                },
            },
        },
    },
};

export default customInputTheme;

